import { FC } from 'react';
import { Flex } from 'antd';
import { DataTable, ModalDialog, SLabelTitle } from '../..';
import { IDataSource, IProps } from './type';
import { getColumns } from './columns';

const BindParentModal: FC<IProps> = (props) => {
  const columns = getColumns(
    props.branches,
    props.cities,
    props.countries,
    props.damageTypes,
    props.organizations,
  );

  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical>
        <SLabelTitle>Seçili Dosyalar</SLabelTitle>
        <DataTable<IDataSource>
          columns={columns}
          dataSource={props.dataSource}
          isPaginationDisplayed={false}
          statusChoices={props.statusChoices}
        />
      </Flex>
    </ModalDialog>
  );
};

export default BindParentModal;
